export default {
  id: 162,
  title: 'Target #162 - Upwards',
  url: 'https://cssbattle.dev/play/162',
  colors: ['#998235', '#0B2429', '#FCBE5C'],
  solution:
    '<a></a><style>body{background:#998235}a{position:fixed;top:140;left:115;width:70;height:70;background:#0b2429;transform:rotate(-45deg);box-shadow:70px 0 #0b2429,70px 70px #fcbe5c}</style>',
}
